import { Card, Grid, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, MenuItem, Select, FormControl, InputLabel, Switch, Autocomplete } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
import { get, postNoResponse } from "utils/WebService";
import MDSnackbar from "components/MDSnackbar";

export default function RegrasFilaCreateEdit({ recordId, closeCreateEdit }) {
    const [nome, setNome] = useState("");
    const [ativo, setAtivo] = useState(true);
    const [itens, setItens] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    useEffect(() => {
        get("/status-ficha/list-all").then((res) => {
            setStatusOptions(res.list || res.data || (Array.isArray(res) ? res : []));
        });

        if (recordId) {
            get(`/regra-fila/by-id/${recordId}`).then((res) => {
                if (res) {
                    setNome(res.nome || "");
                    setAtivo(res.ativo ?? true);
                    setItens(res.itens || []);
                }
            });
        }
    }, [recordId]);

    const handleSave = () => {
        if (!nome) {
            setSbMessage("Informe o nome da regra.");
            setErrorSB(true);
            return;
        }

        const payloadItens = itens.map(item => ({
            ...item,
            statusFichaId: item.statusFichaId === "" ? null : item.statusFichaId,
            regraAgendamento: item.regraAgendamento === "" ? null : item.regraAgendamento,
            saldoMin: item.saldoMin === "" ? null : parseFloat(item.saldoMin),
            saldoMax: item.saldoMax === "" ? null : parseFloat(item.saldoMax),
            pesoOrdem: item.pesoOrdem === "" ? null : parseInt(item.pesoOrdem, 10)
        }));

        const payload = {
            id: recordId,
            nome,
            ativo,
            itens: payloadItens
        };

        postNoResponse("/regra-fila/save", payload).then(() => {
            setSbMessage("Regra salva com sucesso!");
            setSuccessSB(true);
            setTimeout(() => {
                closeCreateEdit();
            }, 1000);
        }).catch(() => {
            setSbMessage("Erro ao salvar regra.");
            setErrorSB(true);
        });
    };

    const handleAddItem = () => {
        setItens([...itens, {
            statusFichaId: null,
            regraAgendamento: null,
            saldoMin: "",
            saldoMax: "",
            pesoOrdem: itens.length + 1
        }]);
    };

    const handleItemChange = (index, field, value) => {
        const newItens = [...itens];
        newItens[index][field] = value;
        setItens(newItens);
    };

    const handleRemoveItem = (index) => {
        const newItens = itens.filter((_, i) => i !== index);
        setItens(newItens);
    };

    return (
        <Card id="regra-fila-form">
            <MDBox display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1 }}>
                    <MDTypography variant="h5"><Icon>arrow_back</Icon></MDTypography>
                </IconButton>
                <MDTypography variant="h6">{recordId ? "Editar Regra" : "Nova Regra"}</MDTypography>
            </MDBox>

            <MDBox component="section" px={3} pb={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={8}>
                        <MDInput 
                            fullWidth 
                            name="nome" 
                            label="Nome da Regra" 
                            variant="standard" 
                            value={nome} 
                            onChange={(e) => setNome(e.target.value)} 
                            required 
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} display="flex" alignItems="center" pt={4} pl={2}>
                        <MDTypography variant="button" fontWeight="regular" color="text">Inativo</MDTypography>
                        <Switch checked={ativo} onChange={(e) => setAtivo(e.target.checked)} />
                        <MDTypography variant="button" fontWeight="regular" color="text">Ativo</MDTypography>
                    </Grid>
                </Grid>

                <MDBox mt={4} mb={2} display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="h6" fontWeight="medium">Regras</MDTypography>
                    <MDButton variant="outlined" color="info" onClick={handleAddItem} size="small">
                        <Icon>add</Icon>&nbsp; Adicionar Regra
                    </MDButton>
                </MDBox>

                <Table>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Status da Ficha</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Agendamento</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Saldo Min (R$)</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Saldo Max (R$)</MDTypography></TableCell>
                            <TableCell><MDTypography variant="caption" fontWeight="bold" color="text">Prioridade</MDTypography></TableCell>
                            <TableCell align="center"><MDTypography variant="caption" fontWeight="bold" color="text">Ação</MDTypography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {itens.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    <MDTypography variant="caption" color="text">Nenhuma regra adicionada.</MDTypography>
                                </TableCell>
                            </TableRow>
                        )}
                        {itens.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Autocomplete
                                        options={statusOptions}
                                        getOptionLabel={(option) => option.ccNome || option.id}
                                        value={statusOptions.find(st => st.id === item.statusFichaId) || null}
                                        onChange={(event, newValue) => {
                                            handleItemChange(index, "statusFichaId", newValue ? newValue.id : null);
                                        }}
                                        renderInput={(params) => <MDInput {...params} variant="standard" placeholder="Qualquer" />}
                                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    <FormControl fullWidth variant="standard">
                                        <Select
                                            value={item.regraAgendamento || ""}
                                            onChange={(e) => handleItemChange(index, "regraAgendamento", e.target.value)}
                                            displayEmpty
                                            sx={{ paddingY: 1 }}
                                        >
                                            <MenuItem value=""><MDTypography variant="button" fontWeight="regular">Ignorar</MDTypography></MenuItem>
                                            <MenuItem value={1}><MDTypography variant="button" fontWeight="regular">Atrasado/Hoje ({"<="})</MDTypography></MenuItem>
                                            <MenuItem value={2}><MDTypography variant="button" fontWeight="regular">Futuro ({">"})</MDTypography></MenuItem>
                                            <MenuItem value={3}><MDTypography variant="button" fontWeight="regular">Sem agendamento</MDTypography></MenuItem>
                                        </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell>
                                    <MDInput
                                        variant="standard"
                                        type="number"
                                        value={item.saldoMin || ""}
                                        onChange={(e) => handleItemChange(index, "saldoMin", e.target.value)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    <MDInput
                                        variant="standard"
                                        type="number"
                                        value={item.saldoMax || ""}
                                        onChange={(e) => handleItemChange(index, "saldoMax", e.target.value)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell>
                                    <MDInput
                                        variant="standard"
                                        type="number"
                                        value={item.pesoOrdem || ""}
                                        onChange={(e) => handleItemChange(index, "pesoOrdem", e.target.value)}
                                        fullWidth
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <IconButton color="error" onClick={() => handleRemoveItem(index)}>
                                        <Icon>delete</Icon>
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <MDBox display="flex" justifyContent="flex-end" mt={4}>
                    <MDButton variant="outlined" color="secondary" onClick={closeCreateEdit} sx={{ mr: 2 }}>
                        Cancelar
                    </MDButton>
                    <MDButton variant="contained" color="info" onClick={handleSave}>
                        Salvar
                    </MDButton>
                </MDBox>
            </MDBox>

            <MDSnackbar
                color={successSB ? "success" : "error"}
                icon={successSB ? "check" : "warning"}
                title={successSB ? "Sucesso" : "Erro"}
                content={sbMessage}
                dateTime=""
                open={successSB || errorSB}
                onClose={() => { setSuccessSB(false); setErrorSB(false); }}
                close={() => { setSuccessSB(false); setErrorSB(false); }}
                bgWhite
            />
        </Card>
    );
}
